/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Section_OrderInputs */

const en_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Section Order`)
};

const de_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschnittsreihenfolge`)
};

const fr_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordre des sections`)
};

const es_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orden de secciones`)
};

const it_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordine sezioni`)
};

const nl_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sectievolgorde`)
};

const pl_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolejnosc sekcji`)
};

const fi_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osioiden järjestys`)
};

const da_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sektionsraekkefolge`)
};

const sv_resume_editor_section_order = /** @type {(inputs: Resume_Editor_Section_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sektionsordning`)
};

/**
* | output |
* | --- |
* | "Section Order" |
*
* @param {Resume_Editor_Section_OrderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_section_order = /** @type {((inputs?: Resume_Editor_Section_OrderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Section_OrderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_section_order(inputs)
	if (locale === "fr") return fr_resume_editor_section_order(inputs)
	if (locale === "es") return es_resume_editor_section_order(inputs)
	if (locale === "it") return it_resume_editor_section_order(inputs)
	if (locale === "nl") return nl_resume_editor_section_order(inputs)
	if (locale === "pl") return pl_resume_editor_section_order(inputs)
	if (locale === "fi") return fi_resume_editor_section_order(inputs)
	if (locale === "da") return da_resume_editor_section_order(inputs)
	if (locale === "sv") return sv_resume_editor_section_order(inputs)
	return en_resume_editor_section_order(inputs)
});